import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { clickContinueEWalletModalSf, checkoutRedirectToCheckoutFromExpressCheckout } from '@wix/bi-logger-ecom-platform-data/v2';
export const createOOIPlatformSiteBILogger = function (biToken, defaults, biLogger) {
  if (defaults === void 0) {
    defaults = {};
  }
  return biLogger.updateDefaults({
    ...defaults,
    bi_token: biToken
  }).logger();
};
export class BIService {
  constructor(controllerConfig) {
    _defineProperty(this, "logger", void 0);
    const loggerFactory = controllerConfig.platformAPIs.biLoggerFactory?.();
    if (!loggerFactory) {
      return;
    }
    this.logger = fixOldLoggerFactoryDueToWorkerYoshiV4(loggerFactory).updateDefaults({
      bi_token: controllerConfig.platformAPIs.bi?.biToken,
      appName: 'Express Checkout',
      _msid: controllerConfig.platformAPIs.bi?.metaSiteId
    }).logger();
  }
  clickContinueEWalletModalSf(checkoutId, cartId) {
    void this.logger.report(clickContinueEWalletModalSf({
      cartId,
      checkoutId
    }));
  }
  reportNavigateToFastFlowCheckout(_ref) {
    let {
      checkoutId,
      cartId,
      purchaseFlowId,
      reason
    } = _ref;
    void this.logger.report(checkoutRedirectToCheckoutFromExpressCheckout({
      cartId,
      checkoutId,
      purchaseFlowId,
      reason
    }));
  }
}
function fixOldLoggerFactoryDueToWorkerYoshiV4(factory) {
  if (factory.factory) {
    return factory.factory();
  }
  return factory;
}
//# sourceMappingURL=BIService.js.map